export const INLINE_NAV_OVERFLOW_THRESHOLD = 5;

export const TENDON_FIXED_MEMBER_GRID_CLASS = "grid grid-cols-[1fr_5rem_auto] gap-2";
export const TENDON_SPATIAL_ROUTE_GRID_CLASS =
  "grid grid-cols-[2.5rem_6rem_minmax(0,1fr)_auto] gap-2";
export const TENDON_WRAP_GEOM_GRID_CLASS =
  "grid grid-cols-[auto_2rem_minmax(0,1fr)] items-center gap-2";

export const LIBRARY_ASSET_LOAD_PROGRESS = {
  XML_FETCH_STARTED: 0.03,
  XML_READY: 0.1,
  MESH_FETCH_START: 0.1,
  MESH_FETCH_SPAN: 0.55,
  MESH_FETCH_COMPLETE: 0.65,
  TEXTURE_FETCH_START: 0.65,
  TEXTURE_FETCH_SPAN: 0.35,
  FILE_FETCH_PHASE_END: 0.36,
  FILES_FETCHED: 0.37,
  FILES_MERGED: 0.4,
  PARSER_READY: 0.42,
  PARSED: 0.48,
  SCENE_MERGED: 0.72,
  KEYFRAMES_APPLIED: 0.8,
  TRANSFORM_APPLIED: 0.86,
  SELECTION_APPLIED: 0.9,
  GRASPS_LOADED: 0.94,
  DONE: 1,
} as const;
